import {
  BrandContent,
  CloseContent,
  HeaderMobileContent,
  IconArrow,
  MerchantName,
} from './header-mobile.styles'
import arrowDown from '../../../assets/arrow_down.svg'
import { useTranslation } from 'react-i18next'
import { useBreakpoint } from '@yuno/sdk-web-core/dist/hooks'
import { useHeaderMobile } from './use-header-mobile'

export const HeaderMobile: React.FC = () => {
  const { closeOrderDetailsMobile, openOrderDetailsMobile, isOrderDetailsMobileShow } = useHeaderMobile()
  const { t } = useTranslation()

  const { isMobile } = useBreakpoint()

  if (!isMobile) {
    return null
  }

  return (
    <HeaderMobileContent>
      <BrandContent onClick={closeOrderDetailsMobile}>
        <MerchantName>{t('Products')}</MerchantName>
      </BrandContent>
      {isOrderDetailsMobileShow ? (
        <CloseContent onClick={closeOrderDetailsMobile}>
          {t('Close')}
          <IconArrow src={arrowDown} alt="arrow down icon" />
        </CloseContent>
      ) : (
        <CloseContent onClick={openOrderDetailsMobile}>
          {t('Show details')}
          <img src={arrowDown} alt="arrow down icon" />
        </CloseContent>
      )}
    </HeaderMobileContent>
  )
}
